import { RecordingData } from "capacitor-voice-recorder";

export class AudioPlayer {
  constructor(public audio: HTMLAudioElement) {
  }

  async playData(data: RecordingData | undefined): Promise<void> {
    if (!data || !data.value) return;

    let audio = this.audio;
    return new Promise<void>((resolve, reject) => {
      const recordDataBase64 = data.value.recordDataBase64 ?? "";
      const mimeType = data.value.mimeType ?? "audio/wav";
      let src: string;
      if (recordDataBase64.startsWith('data:audio'))
        src = recordDataBase64;
      else
        src = `data:${mimeType};base64,${recordDataBase64}`;

      audio.src = src;
      audio.oncanplaythrough = () => {
        audio.play().then(() => {
          // 재생 성공
        }).catch(reject); // 재생 실패 시 reject
      };
      audio.load();
      audio.onended = () => resolve();
      // console.log('### Size of data.value.recordDataBase64 is', recordDataBase64.length, `${data.value.msDuration} ms`);
    });
  }

  stop() {
    this.audio.pause();
  }

  continue() {
    this.audio.play();
  }
}
